import { vizag2026 } from "./vizag2026"

// Keep historical keys and URLs stable when adding editions.
export const FEATURED_EDITION = "vizag-2026"

export const editions = [
  { id: vizag2026.id, name: `${vizag2026.shortName} Edition`, route: vizag2026.route, date: vizag2026.date, location: vizag2026.venue },
  { id: "chennai", name: "CTS 2026 Chennai Edition", route: "/chennai", date: "July 3, 2026", location: "Chennai" },
  { id: "bangalore", name: "CTS 2025 Bengaluru Edition", route: "/bangalore", date: "November 7, 2025", location: "Bengaluru" },
  { id: "vizag", name: "CTS 2025 Vizag Edition", route: "/vizag", date: "August 22, 2025", location: "Visakhapatnam" },
]

export const editionRoute = (id) => editions.find((edition) => edition.id === id)?.route || "/"
